var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaitingpickupStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 33,
    viewBox: "0 0 87 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1566 33.0003H0C0.923706 29.8227 5.44147 23.4674 16.1229 23.4674C29.4746 23.4674 32.7496 16.3177 42.5745 6.41815C50.4344 -1.50151 74.9042 1.0406 86.1566 3.30162V33.0003Z",
    fill: "url(#paint0_linear_3846_3559)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.809 3.26235C76.44 1.38505 56.1599 -0.87976 47.0064 3.62576C35.5647 9.25766 35.5647 21.6114 20.1431 23.0648C13.2359 23.7158 7.4577 23.6099 1.73682 30.8768",
    stroke: "#8E8E8E",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3846_3559",
    x1: 105.572,
    y1: 1.03906,
    x2: 105.572,
    y2: 33.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8E8E",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E8E8E",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingpickupStatus);
export default __webpack_public_path__ + "static/media/waitingpickup-status.7519a179312ae8416a056e0a47462eb5.svg";
export { ForwardRef as ReactComponent };